<template>
	<div class='projects-view view'>
        <Project class='project'>
			<template v-slot:title>
				<h2>filmadder</h2>
			</template>

			<template v-slot:info>
				<article class='project__info'>
					<p>A film tracking app with social network capabilities.</p>
					<p>filmadder is a pet project I'm currently working on with my friend. The code is available on github and the beta version of the android app on google play.</p>
					<h4><span>Design:</span> Adobe Illustrator & Figma</h4>
					<h4><span>Implementation:</span> React Native</h4>
				</article>
			</template>

			<template v-slot:links>
				<h5>Check on:</h5>
				<article class='project__links'>
					<a class='gplay-badge' href='https://play.google.com/store/apps/details?id=com.stelaseldano.filmadderapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
					<br />
					<a class='link' href='https://github.com/filmadder/mobile'>github</a>
					<a class='link' href='https://dribbble.com/shots/5807685-Filmadder'>dribbble</a>
					<a class='link' href='https://www.figma.com/proto/d19c4u8BnvUFHgRRCkLC6P/filmadder?node-id=0%3A1&scaling=min-zoom'>figma</a>
				</article>
			</template>

			<template v-slot:images>
				<article class='project__images'>
					<!-- <img class='project__image' src='../assets/filmadder/profile.png' height='350' /> -->
					<img class='project__image' src='../assets/filmadder/film.png' />
					<img class='project__image' src='../assets/filmadder/profile.png' />
				</article>
			</template>
		</Project>

		<Project class='project'>
			<template v-slot:title>
				<h2>CSS quests</h2>
			</template>

			<template v-slot:info>
				<article class='project__info'>
					<p>Drawing challenges for people who like creating things with CSS only.</p>
					<h4><span>Implementation:</span> HTML, CSS, JavaScript</h4>
				</article>
			</template>

			<template v-slot:links>
				<article class='project__links'>
					<h5>Check on:</h5>
					<a class='link' href='https://cssquests.com'>cssquests.com</a>
				</article>
			</template>
		</Project>
	</div>
</template>

<script>
import Project from './projects/Project';

export default {

	name: 'Projects',

	components: {
		Project
	}
}
</script>

<style lang="less" scoped>
@import '../colours';

.project {
	display: flex;
	margin-bottom: 150px;
}

.project__info {
	flex: 1;
	display: flex;
	min-width: 250px;
	flex-direction: column;
}

.project__info h4 span {
	font-weight: normal;
}

.project__images {
	flex: 1;
	margin: 0 0 0 70px;
	display: flex;
	align-items: center;
}

.project__image {
	margin: 0 10px;

	&:nth-child(1) {
		height: 450px;
	}

	&:nth-child(2) {
		height: 350px;
	}
}

.project__links {

	.gplay-badge {

		display: inline-block;

		img {
			height: 80px;
		}
	}
}


@media screen and (max-width: 1250px) {

	.project {
		flex-direction: column;
		justify-content: center;
		margin-bottom: 100px;
	}

	.project__images {
		justify-content: center;
		margin: 40px 0 0 0;
	}

	.project__image {

		&:nth-child(1) {
			height: 400px;
		}

		&:nth-child(2) {
			height: 300px;
		}
	}
}

@media screen and (max-width: 550px) {

	.project__images {
		flex-direction: column;
	}

	.project__image {
		margin: 10px 0;
	}
}

</style>